import { Col, Row, Tooltip } from 'antd'
import React from 'react'
import { Link } from 'react-router-dom';
import { useBoundStore } from '../../../../store/useBoundStore';

const GLOBAL_DASH_INITIAL_AGENCY_DATE_RANGE_KEY = "globalDashboardInitialAgencyDateRange";

function Activity_card({ orderIndex, md, img = "", name, count, link, index = 0, drillDownDateRange }) {

  let countmd = 6, namemd = 11;

  if (!img) {
    countmd = 13;
    namemd = 11;
  }

  let iconWidth = {
    0: 15,
    1: 12,
    2: 10,
  }


  const getSelectedDate = () => {
    if (
      drillDownDateRange &&
      drillDownDateRange.start_date &&
      drillDownDateRange.end_date
    ) {
      return drillDownDateRange;
    }

    const globalDashboardFilter = useBoundStore.getState().GlobalDashboardFilter || {};
    const initialAgencyDateRange = globalDashboardFilter.initialAgencyDateRange || {};
    const storedInitialAgencyDateRange = localStorage.getItem(GLOBAL_DASH_INITIAL_AGENCY_DATE_RANGE_KEY);

    if (initialAgencyDateRange.start_date && initialAgencyDateRange.end_date) {
      return initialAgencyDateRange;
    }

    if (storedInitialAgencyDateRange) {
      try {
        const parsedDateRange = JSON.parse(storedInitialAgencyDateRange);

        if (parsedDateRange.start_date && parsedDateRange.end_date) {
          return parsedDateRange;
        }
      } catch (error) {
        console.error("Error parsing initial global dashboard agency date range:", error);
      }
    }

    return {
      start_date: "2010-01-01",
      end_date: "2050-01-01"
    }
  };

  const handleClick = () => {

    const selectedDateRange = getSelectedDate();
    const initialDateRange = {
      start_date: selectedDateRange.start_date,
      end_date: selectedDateRange.end_date,
    };

    useBoundStore.getState().setFsFilters({ datemodified: initialDateRange, searchText: "", page: 1, filter_by_column_name: {} });
  }

  // Direct container reference to override App.js configuration
  const getCustomContainer = () => document.body;

  return (

    <Col md={md}
      className='activity_item_info'>
      <Row style={{ height: '100%', position: 'relative' }}>
        {img &&
          <Col md={7} className='justifytCenter'>
            <div className='iconShadow'>
              <img width={iconWidth[index]}
                alt='' src={require(`../../../../assets/icons/dashboard/bfile_result/${img}.svg`)} />
            </div>

          </Col>}
        <Col className={index === 3 ? 'justifytCenter' : 'justifytstart'} md={countmd} >
          <span className='count'>
            <Tooltip
              title={count}
              getPopupContainer={getCustomContainer}
              arrowPointAtCenter={true}
              placement="top"
            >
              <Link to={link} onClick={() => handleClick()}>{count}</Link>
            </Tooltip>
          </span>
        </Col>
        <Col md={namemd} className='justifytstart'>
          <span className='name'>{name}</span>
        </Col>
      </Row>
    </Col>

  )
}

export default Activity_card



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/parts/EA_And_LSP/ActivityCard.js